import { jsxs as c, Fragment as X, jsx as t } from "react/jsx-runtime";
import * as f from "react";
import { cn as o } from "../../../lib/utils.js";
import { AnimatePresence as q, motion as w } from "framer-motion";
import { MoreHorizontal as D, X as G } from "lucide-react";
const J = f.forwardRef(({
  // Legacy props
  items: n,
  activeItem: a,
  onItemClick: s,
  // New props
  apps: i,
  activeApp: d,
  onAppChange: u,
  maxVisibleTabs: r = 4,
  // Shared props
  variant: x = "default",
  showMoreMenu: _ = !0,
  safeAreaBottom: z = !0,
  className: R
}, S) => {
  const [C, N] = f.useState(!1), b = !!i, m = f.useMemo(() => i ? i.map((e) => ({
    id: e.id,
    label: e.label,
    icon: e.icon,
    badge: e.badge,
    active: e.id === d
  })) : n || [], [i, d, n]), [v, k] = f.useState(() => m.slice(0, r).map((e) => e.id));
  f.useEffect(() => {
    const e = m.map((l) => l.id);
    k((l) => {
      const p = l.filter((g) => e.includes(g));
      if (p.length >= r)
        return p.slice(0, r);
      const y = e.filter((g) => !p.includes(g));
      return [...p, ...y].slice(0, r);
    });
  }, [m.length, r]);
  const P = v.map((e) => m.find((l) => l.id === e)).filter(Boolean), h = m.filter((e) => !v.includes(e.id)), E = h.length > 0 && _, F = h.some((e) => e.id === (b ? d : a) || e.active), M = f.useCallback((e) => {
    e.onClick ? e.onClick() : e.href && (window.location.href = e.href), b ? u == null || u(e.id) : s == null || s(e.id), k((l) => {
      if (l.includes(e.id))
        return l;
      const p = b ? d : a, y = [...l].reverse().findIndex((H) => H !== p), g = y === -1 ? l.length - 1 : l.length - 1 - y, B = [...l];
      return B[g] = e.id, B;
    }), N(!1);
  }, [b, u, s, d, a]), j = b ? d : a;
  return c(X, { children: [t("nav", { ref: S, className: o(
    "fixed bottom-0 left-0 right-0 z-[110] bg-surface/95 backdrop-blur-3xl shadow-[0_-4px_24px_rgba(0,0,0,0.06)] dark:shadow-[0_-4px_24px_rgba(0,0,0,0.4)] border-t border-border-color/50",
    x === "pill" && "mx-4 mb-4 rounded-2xl border shadow-premium",
    x === "default" && "shadow-lg",
    z && "pb-safe",
    // iOS safe area
    R
  ), children: c("div", { className: o("flex items-center justify-around", "py-2 px-2"), children: [P.map((e) => {
    const l = j === e.id || e.active || !1;
    return t(I, { item: e, isActive: l, variant: x, onClick: () => M(e) }, e.id);
  }), E && c("button", { onClick: () => N(!0), className: o("relative flex flex-col items-center justify-center min-h-[48px] px-3 py-2", "rounded-xl transition-all duration-200", F ? "text-lpr-teal dark:text-lpr-gold" : "text-text-secondary hover:text-text-primary"), children: [c("div", { className: "relative", children: [t(D, { className: "w-5 h-5" }), h.some((e) => e.badge) && t("span", { className: "absolute -top-1 -right-1 w-2 h-2 rounded-full bg-lpr-red" })] }), x !== "minimal" && t("span", { className: "text-[10px] font-medium mt-1", children: "More" })] })] }) }), t(q, { children: C && t(O, { items: h, allItems: m, activeId: j, onSelect: M, onClose: () => N(!1) }) })] });
});
J.displayName = "BottomNavigation";
const I = f.memo(({ item: n, isActive: a, variant: s, onClick: i }) => c("button", { onClick: i, className: o("relative flex flex-col items-center justify-center min-h-[48px] px-3 py-2", "rounded-xl transition-all duration-200", a ? "text-lpr-teal dark:text-lpr-gold" : "text-text-secondary hover:text-text-primary active:scale-95"), children: [a && s === "default" && t(w.div, { layoutId: "bottom-nav-indicator", className: "absolute -top-0.5 left-1/2 -translate-x-1/2 w-8 h-1 rounded-full bg-lpr-teal dark:bg-lpr-gold", transition: { type: "spring", stiffness: 400, damping: 30 } }), c("div", { className: o("relative transition-transform duration-200", a && "scale-110"), children: [n.icon, n.badge !== void 0 && t("span", { className: o("absolute -top-1.5 -right-2 flex items-center justify-center", "min-w-[16px] h-4 px-1 rounded-full", "bg-lpr-red text-white text-[9px] font-bold"), children: typeof n.badge == "number" && n.badge > 99 ? "99+" : n.badge })] }), s !== "minimal" && t("span", { className: o("text-[10px] font-medium mt-1 max-w-[56px] truncate", a && "font-semibold"), children: n.label })] }));
I.displayName = "TabButton";
const O = f.memo(({ items: n, allItems: a, activeId: s, onSelect: i, onClose: d }) => {
  const u = a;
  return t(w.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.15 }, className: "fixed inset-0 z-[120] bg-lpr-charcoal/60 backdrop-blur-sm", onClick: d, children: c(w.div, { initial: { y: "100%" }, animate: { y: 0 }, exit: { y: "100%" }, transition: { type: "spring", stiffness: 300, damping: 30 }, className: o(
    "absolute bottom-0 left-0 right-0",
    "bg-white dark:bg-lpr-charcoal border-t border-border-color rounded-t-3xl",
    "pb-safe"
    // iOS safe area
  ), onClick: (r) => r.stopPropagation(), children: [c("div", { className: "flex items-center justify-between px-5 py-4 border-b border-border-color", children: [t("h3", { className: "text-sm font-semibold text-text-primary", children: "All Apps" }), t("button", { onClick: d, className: "p-2 -mr-2 rounded-xl hover:bg-border-color text-text-secondary transition-colors", children: t(G, { className: "w-5 h-5" }) })] }), t("div", { className: "p-4 max-h-[60vh] overflow-y-auto", children: t("div", { className: "grid grid-cols-4 gap-3", children: u.map((r) => {
    const x = s === r.id || r.active;
    return c("button", { onClick: () => i(r), className: o("flex flex-col items-center gap-2 p-3 rounded-2xl", "transition-all duration-200 active:scale-95", x ? "bg-lpr-teal/10 dark:bg-lpr-gold/10" : "hover:bg-border-color/50"), children: [c("div", { className: o("relative w-12 h-12 flex items-center justify-center rounded-2xl", "transition-colors", x ? "bg-lpr-teal/10 dark:bg-lpr-gold/10 text-lpr-teal dark:text-lpr-gold" : "bg-border-color/50 text-text-secondary"), children: [r.icon, r.badge !== void 0 && t("span", { className: o("absolute -top-1 -right-1 flex items-center justify-center", "min-w-[18px] h-[18px] px-1 rounded-full", "bg-lpr-red text-white text-[10px] font-bold"), children: typeof r.badge == "number" && r.badge > 99 ? "99+" : r.badge })] }), t("span", { className: o("text-[11px] font-medium text-center leading-tight", x ? "text-lpr-teal dark:text-lpr-gold" : "text-text-secondary"), children: r.label })] }, r.id);
  }) }) })] }) });
});
O.displayName = "MoreMenuOverlay";
const K = f.forwardRef(({ count: n, variant: a = "count", color: s = "red", className: i }, d) => {
  const u = {
    red: "bg-lpr-red text-white",
    blue: "bg-lpr-teal text-white",
    green: "bg-lpr-green text-white",
    yellow: "bg-lpr-gold text-lpr-charcoal"
  };
  return a === "dot" ? t("span", { ref: d, className: o("absolute -top-1 -right-1 h-3 w-3 rounded-full", u[s], i) }) : t("span", { ref: d, className: o("absolute -top-2 -right-2 h-5 min-w-[20px] flex items-center justify-center rounded-full text-xs font-bold px-1", u[s], i), children: n > 99 ? "99+" : n });
});
K.displayName = "BottomNavBadge";
export {
  K as BottomNavBadge,
  J as BottomNavigation
};
//# sourceMappingURL=BottomNav.js.map
